import httpService from './httpService';

export const getSignRequirements = (): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Documents/sign/requirements`);
  return httpService.getTyped<any>(endpoint);
};

export const generateDocuSignURL = (recipientId: number, cancelToken): Promise<any> => {
  let returnURL = '';
  if (location.hostname === 'localhost') {
    returnURL = 'https://' + location.hostname + ':' + location.port + `/docusign/redirect/${recipientId}`;
  } else {
    returnURL = 'https://' + location.hostname + `/docusign/redirect/${recipientId}`;
  }
  let body = { returnUrl: returnURL };
  let endpoint = httpService.getEndpointURL(`/DocuSignEnvelopes/sign/${recipientId}/uri`);
  return httpService
    .post(endpoint, body, { cancelToken })
    .then((res) => res.data)
    .catch((err) => {
      console.log('> generateDocuSignURL error ', err);
    });
};

export const updateEnvelopeState = (recipientId: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/DocuSignEnvelopes/${recipientId}/state`);
  return httpService
    .post(endpoint)
    .then((res) => res.data)
    .catch((err) => {
      console.log('> updateEnvelopeState error ', err);
    });
};
